var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"content",class:_vm.$isMobile && 'content-mobile'},[_c('comp-room',{attrs:{"sdkAppId":Number(_vm.sdkAppId),"secretKey":_vm.secretKey,"userId":_vm.userId,"roomId":Number(_vm.roomId),"cameraId":_vm.cameraId,"microphoneId":_vm.microphoneId}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }